"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useGetHistory = exports.usePeerSuggestion = exports.useGetActiveCycles = void 0;
const react_query_1 = require("react-query");
const FormalReviewClient_1 = require("client/FormalReviewClient");
const formalReviewKeys_1 = __importDefault(require("consts/queryKeys/formalReviewKeys"));
const useGetActiveCycles = (params, options) => {
    const fetchActiveCycles = (olderThan) => {
        const queryParams = {
            ...params,
            ...(olderThan && { olderThan })
        };
        return (0, FormalReviewClient_1.getActiveCycles)(queryParams);
    };
    return (0, react_query_1.useInfiniteQuery)(formalReviewKeys_1.default.formalReview.activeCycles(params), ({ pageParam }) => fetchActiveCycles(pageParam), options);
};
exports.useGetActiveCycles = useGetActiveCycles;
const usePeerSuggestion = (cycleId, targetId, params, options) => {
    const fetchSuggestions = (olderThan) => {
        const queryParams = {
            ...params,
            ...(olderThan && { olderThan })
        };
        return (0, FormalReviewClient_1.getPeerSuggestions)(cycleId, targetId, queryParams);
    };
    return (0, react_query_1.useInfiniteQuery)(formalReviewKeys_1.default.formalReview.peerSuggestions(params), ({ pageParam }) => fetchSuggestions(pageParam), options);
};
exports.usePeerSuggestion = usePeerSuggestion;
const useGetHistory = (cycleId, targetId, options) => {
    const fetchHistory = (olderThan) => {
        const queryParams = {
            ...(olderThan && { olderThan }),
            limit: 10
        };
        return (0, FormalReviewClient_1.getPeerHistory)(cycleId, targetId, queryParams);
    };
    return (0, react_query_1.useInfiniteQuery)(formalReviewKeys_1.default.formalReview.peerHistory(cycleId, targetId), ({ pageParam }) => fetchHistory(pageParam), options);
};
exports.useGetHistory = useGetHistory;
